import type { FC } from "react";

import type { StoreDetailsComponentProps } from "@locators/components/StoreDetails";
import { StoreDetailsMap } from "@locators/components/StoreDetails/components";

import styles from "./StoreDetailsV1.module.scss";

export const StoreDetailsV1: FC<StoreDetailsComponentProps> = ({
  isHeaderAddressVisible,
  storeDetails,
  storeIcons,
  componentLevelLanguage,
}) => {
  return (
    <>
      {isHeaderAddressVisible && (
        <div className={styles.headerWrapper}>
          <div className={styles.headerSpacer}></div>
          <div className={styles.headerRight}>
            <h1 className={styles.storeDetailsHeadline}>
              {storeDetails.store.StoreName} {storeDetails.store.Street}
            </h1>
          </div>
        </div>
      )}
      <div className={styles.storeMapContainer}>
        <StoreDetailsMap storeIcons={storeIcons} componentLevelLanguage={componentLevelLanguage} {...storeDetails} />
      </div>
    </>
  );
};
